define('threadsMenuView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'buttonView',
  'selectView',
  'settings',
  'template!threadsMenuView',
  'notificationCenter',
  'entities/mails',
  'jstree'
], function(
  App,
  Module,
  Backbone,
  Marionette,
  _,
  ButtonView,
  SelectView,
  Settings,
  Tpl,
  NotificationCenter
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'menu-view',

    ui: {
      folders: '.folders',
      favorite: '.favorite'
    },

    regions: {
      newMailRegion: '.new-mail-region',
      mailsRegion: '.mails-region'
    },

    events: {
      'click @ui.favorite': 'onFavorite'
    },

    initialize: function() {
      var cookieMailSecId = Settings.get('currentThreadMailSecIdCookie', true) || undefined;
      var cookieMailFolder = Settings.get('currentThreadFolderCookie', true) || 'INBOX';

      this.refreshTimeout = null;
      this.mailSecId = this.options.from || cookieMailSecId;
      this.folder = this.options.folder || cookieMailFolder;
      this.emitterId = undefined;

      this.setupNotificationListeners();

      this.MailsCollection = Backbone.Collection.extend({
        comparator: _.bind(function (a, b) {
          var favoritesJson = Settings.get('favoriteFromMails', true);
          var favorites = [];
          if (favoritesJson) {
            favorites = JSON.parse(favoritesJson);
          }
          var aIsFavorite = favorites.indexOf(a.get('id')) !== -1;
          var bIsFavorite = favorites.indexOf(b.get('id')) !== -1;
          if (aIsFavorite && !bIsFavorite) return -1;
          if (!aIsFavorite && bIsFavorite) return 1;
          var aValue = a.get('value').toLowerCase();
          var bValue = b.get('value').toLowerCase();
          if (aValue < bValue) return -1;
          if (aValue > bValue) return 1;
          return 0;
        }, this)
      });

      this.mailsCollection = new this.MailsCollection();
    },

    validateNotificationResponse: function(response) {
      return response &&
          response.content &&
          response.content.content &&
          response.content.content.data &&
          response.content.emitterId === this.emitterId &&
          typeof response.content.content.text === 'string' &&
          response.content.content.text.startsWith(this.mailSecId);
    },

    updateEmitterId: function(response) {
      if (response.content && !isNaN(response.content.emitterId)) {
        var newEmitterId = parseInt(response.content.emitterId, 10);
        if (this.emitterId === undefined || newEmitterId > this.emitterId) {
          this.emitterId = newEmitterId;
        }
      }
    },

    handleMessageNotification: function(response) {
      this.updateEmitterId(response);
      if (!this.validateNotificationResponse(response)) return;

      var that = this;
      response.content.content.data.forEach(function(label) {
        if(label.id === that.folder || that.folder === 'ALL MAILS') {
          that.refreshFolder();
        }
      });
    },

    handleLabelNotification: function(response) {
      this.updateEmitterId(response);
      if (!this.validateNotificationResponse(response)) return;

      this.refreshFolders(response.content.content.data);
      if(this.folder === 'ALL MAILS' || response.content.content.text.indexOf(this.folder) !== -1) {
        this.refreshFolder();
      }
    },

    setupNotificationListeners: function() {
      var nc = NotificationCenter.getInstance();
      var events = NotificationCenter.events;
      nc.on(events.EMAILS_GMAIL_API_MESSAGE_ADDED, this.handleMessageNotification, this);
      nc.on(events.EMAILS_GMAIL_API_MESSAGE_DELETED, this.handleMessageNotification, this);
      nc.on(events.EMAILS_GMAIL_API_MESSAGE_LABELS_ADDED, this.handleLabelNotification, this);
      nc.on(events.EMAILS_GMAIL_API_MESSAGE_LABELS_REMOVED, this.handleLabelNotification, this);
    },

    onDestroy: function() {
      this.removeNotificationListeners();
    },

    removeNotificationListeners: function() {
      var nc = NotificationCenter.getInstance();
      var events = NotificationCenter.events;
      nc.off(events.EMAILS_GMAIL_API_MESSAGE_ADDED, this.handleMessageNotification, this);
      nc.off(events.EMAILS_GMAIL_API_MESSAGE_DELETED, this.handleMessageNotification, this);
      nc.off(events.EMAILS_GMAIL_API_MESSAGE_LABELS_ADDED, this.handleLabelNotification, this);
      nc.off(events.EMAILS_GMAIL_API_MESSAGE_LABELS_REMOVED, this.handleLabelNotification, this);
    },

    refreshFolders: function(data) {
      clearTimeout(this.refreshTimeout);
      var that = this;
      function rt() {
        if(that.ui.folders && that.ui.folders.jstree) {
          var tree = that.ui.folders.jstree(true);
          if(tree) {
            tree.settings.core.data = data.map(that.processItem.bind(that));
            tree.refresh();
          }
        }
      }
      this.refreshTimeout = setTimeout(rt, 10 * 1000);
    },

    processItem: function(item) {
      var itemText = item.text;
      if (item.unreadMessages) {
        itemText = '<span class="unread-messages">' + itemText + '</span>';
      }

      var folder = {
        id: item.id,
        text: itemText,
        messageCount: item.messageCount,
        unreadMessages: item.unreadMessages
      };

      if(item.id === this.folder){
        this.trigger('folder:selected', item.id);
      }

      if (item.children && item.children.length > 0) {
        folder.children = item.children.map(this.processItem.bind(this));
      } else {
        folder.children = [];
      }

      return folder;
    },

    onRender: function() {
      this.newButton = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('mails.new'),
        title: _.i18n('mails.new')
      });

      this.getRegion('newMailRegion').show(this.newButton);
      this.newButton.on('click', this.onNewMail, this);

      this.mailsView = new SelectView({
        collection: this.mailsCollection
      });
      this.getRegion('mailsRegion').show(this.mailsView);
      this.mailsView.on('change', _.bind(this.onMailChange, this));

      App.request('threads:getFromMails').done(_.bind(function(addresses) {
        var favoritesJson = Settings.get('favoriteFromMails', true);
        var favorites = [];
        if (favoritesJson) {
          favorites = JSON.parse(favoritesJson);
        }

        _.each(addresses, function (address) {
          var isFavorite = favorites.indexOf(address.secId) !== -1;
          var displayValue = isFavorite ? address.email + ' *' : address.email;
          this.mailsCollection.add({id: address.secId, value: displayValue});
        }, this);

        this.mailsCollection.sort();

        if(addresses.length > 0) {
          if(this.mailSecId === undefined || this.mailSecId === 'undefined') {
            this.mailSecId = addresses[0].secId;
            Settings.set('currentThreadMailSecIdCookie', this.mailSecId, true);
          }
          this.options.listView.threadsView.setMailSecId(this.mailSecId);
          this.mailsView.setSelected(this.mailSecId);
          if(this.ui.folders && this.ui.folders.jstree)
            this.ui.folders.jstree('refresh');
        }
      }, this));

      this.ui.folders.jstree({
        'core': {
          'data': _.bind(this.fetch, this),
          'check_callback': true,
          'multiple' : false,
          'themes': {
            'responsive': true,
            'variant': 'small',
            'stripes': false
          },
          'animation': 0
        },
        'plugins': ['dnd']
      }).on('open_node.jstree', _.bind(function(e, data) {
        if(data.node.state.fetch)
          return;
        this.ui.folders.jstree('open_node', data.node);
      }, this)).on('activate_node.jstree', _.bind(function(e, data) {
        if(this.folder !== data.node.id) {
          this.folder = data.node.id;
          Settings.set('currentThreadFolderCookie', this.folder, true);
          this.options.listView.threadsView.footerView.setCurrentPage(1);
          this.trigger('folder:selected', data.node.id, true);
        }
        App.navigate('threads/' + encodeURIComponent(this.mailSecId) + '/' + encodeURIComponent(data.node.id), {trigger: false});
      }, this)).on('select_node.jstree', _.bind(function(e, data) {
        if(this.folder !== data.node.id) {
          this.folder = data.node.id;
          Settings.set('currentThreadFolderCookie', this.folder, true);
          this.options.listView.threadsView.footerView.setCurrentPage(1);
          this.trigger('folder:selected', data.node.id, true);
        }
      }, this)).on('loaded.jstree', _.bind(function() {
        this.ui.folders.jstree('select_node', this.folder);
        this.trigger('folder:selected', this.folder);
      }, this)).on('refresh.jstree', _.bind(function() {
        this.ui.folders.jstree('select_node', this.folder);
      }, this));

      this.renderFavorite();
    },

    refreshFolder: function() {
      clearTimeout(this.refreshTimeoutFolder);
      var that = this;
      function rtf() {
        that.trigger('folder:selected', that.folder);
      }
      this.refreshTimeoutFolder = setTimeout(rtf, 10 * 1000);
    },

    renderFavorite: function() {
      var mails = Settings.get('favoriteFromMails', true);
      if(mails) {
        if(mails.indexOf(this.mailSecId) !== -1)
          this.ui.favorite.attr('data-value', 'selected');
        else
          this.ui.favorite.attr('data-value', 'unselected');
      }
    },

    fetch: function (node, cb) {
      var defer = $.Deferred();

      if (this.fetchRequest && this.fetchRequest.readyState !== 4) {
        return this.fetchRequest;
      }

      if(!this.mailSecId)
        cb([]);

      var params = {};
      params.folder = null;

      if(node.id !== '#')
        params.folder = node.id;

      // Reuse the mails folder endpoint since folders/labels are shared
      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('mails:get-folders-url', this.mailSecId, params),
        headers: {
          'Cache-Control': 'no-cache'
        },
        success: _.bind(function (items) {
          if(items) {
            var folders = items.map(this.processItem.bind(this));
            cb(folders);
            defer.resolve();
          }
        }, this),
        complete: _.bind(function() {
          this.fetchRequest = null;
        }, this)
      });

      return defer.promise();
    },

    onMailChange: function() {
      clearTimeout(this.refreshTimeout);
      clearTimeout(this.refreshTimeoutFolder);

      this.folder = 'INBOX';
      Settings.set('currentThreadFolderCookie', this.folder, true);
      this.mailSecId = this.mailsView.getSelected().get('id');
      Settings.set('currentThreadMailSecIdCookie', this.mailSecId, true);
      this.options.listView.threadsView.folder = this.folder;
      this.options.listView.threadsView.footerView.setCurrentPage(1);
      this.options.listView.threadsView.setMailSecId(this.mailSecId);
      this.ui.folders.jstree('refresh');

      App.navigate('threads/' + encodeURIComponent(this.mailSecId) + '/' + encodeURIComponent(this.folder), {trigger: false});
      this.renderFavorite();
    },

    onNewMail: function() {
      // Reuse the email compose from mails module
      if(!this.mailSecId) return;

      require(['emailView'], _.bind(function(EmailView) {
        var from = null;
        _.each(this.mailsCollection.models, function(model) {
          if(model.get('id') === this.mailSecId)
            from = model.get('value');
        }, this);

        if(!from) return;

        EmailView.prototype.open({
          from: from,
          allowFromSelection: true,
          title: '',
          id: 'new-mail',
          templateType: 'MAIL_SIGN',
          fetchTemplateData: _.bind(function () {
            var defer = $.Deferred();
            defer.resolve({ customer: {} });
            return defer.promise();
          }, this),
          templateLocale: Settings.get('lang')
        });
      }, this));
    },

    onFavorite: function() {
      var value = this.ui.favorite.attr('data-value');

      if(value === 'selected')
        this.ui.favorite.attr('data-value', 'unselected');
      if(value === 'unselected')
        this.ui.favorite.attr('data-value', 'selected');

      var mailsJson = Settings.get('favoriteFromMails', true);
      var mails = [];
      if(mailsJson)
        mails = JSON.parse(mailsJson);

      var isNowFavorite = this.ui.favorite.attr('data-value') === 'selected';

      if(mails.indexOf(this.mailSecId) === -1 && isNowFavorite)
        mails.push(this.mailSecId);

      if(mails.indexOf(this.mailSecId) !== -1 && !isNowFavorite)
        mails.splice(mails.indexOf(this.mailSecId), 1);

      Settings.set('favoriteFromMails', JSON.stringify(mails), true);

      var mailModel = this.mailsCollection.get(this.mailSecId);
      if (mailModel) {
        var currentValue = mailModel.get('value');
        var baseEmail = currentValue.endsWith(' *') ? currentValue.slice(0, -2) : currentValue;
        var newValue = isNowFavorite ? baseEmail + ' *' : baseEmail;
        mailModel.set('value', newValue);
      }

      this.mailsCollection.sort();
    }
  });
});

